export function escapeHtml(str: string) {
  if (str !== undefined) {
    return str.replace(/(<([^>]{1,99})>)/gi, '')
  } else {
    return ''
  }
}
